import React from "react";
export default (function () {
    return React.createElement("svg", { width: "24", height: "22", viewBox: "0 0 24 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { y: "12", width: "24", height: "3", fill: "currentColor " }),
        React.createElement("rect", { y: "18", width: "24", height: "3", fill: "currentColor " }),
        React.createElement("rect", { y: "6", width: "24", height: "3", fill: "currentColor " }),
        React.createElement("rect", { width: "24", height: "3", fill: "currentColor " }));
});
//# sourceMappingURL=medium-density.js.map